// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__JhsJA","content":"RecentSearches_content__1SlkA"};